export default __webpack_public_path__ + "static/media/keyboard_tool.07e79189.png";